export const customeStyle = {
    sucessColor:"#dd4498",
    errorColor:"#688ad5",
    fadedGrey:"#A9A9A9",
    typography: {
        subhading: { lg: "0.9rem", md: "0.9", sm: "0.9rem", xs: "0.9rem" },
        subhading1: { lg: "0.7rem", md: "0.7rem", sm: "0.7rem", xs: "0.7rem" },
    },
    buttomfont:"0.875rem",
    buttomfont1:"0.7rem"

}